import { BaseApiService } from '@/services/base-service';
import { Response } from '@/types';
import { EditableCoursesRequest } from '../types';

export class EditableCoursesRequestService extends BaseApiService {
  private readonly base_path = 'courses_requests';

  async get_selection_lists(): Promise<EditableCoursesRequest.SelectionListsResponse> {
    const url = `${this.base_path}/selection_lists`;
    const { data } = await this.http_client.get<EditableCoursesRequest.SelectionListsResponse>(url);

    return data;
  }

  async get_editable_courses_request(request_id: string | number): Promise<EditableCoursesRequest.Response> {
    const url = `${this.base_path}/${request_id}/editable`;
    const { data } = await this.http_client.get<EditableCoursesRequest.Response>(url);

    return data;
  }

  async send_new_courses_request(courses_request: EditableCoursesRequest.ItemToSend) {
    const { data } = await this.http_client.post<Response<null>>(
      this.base_path,
      courses_request,
    );

    return data.code;
  }

  async edit_courses_request(id: number, courses_request: EditableCoursesRequest.ItemToSend) {
    const url = `${this.base_path}/${id}`;
    const { data } = await this.http_client.patch(url, courses_request);

    return data.code;
  }
}

export const default_courses = (): EditableCoursesRequest.Courses => ({
  paid: {
    access: true,
    items: [],
  },
  free: {
    access: true,
    items: [],
  },
});
